import { NgClass, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { IOutcome, ISportEvent } from '@frontend/oxygen/shared-utils';

import { DeviceService } from '../../../core/services/device/device.service';
import { VirtualSharedService } from '../../services/virtual/virtual-shared.service';

@Component({
    selector: 'virtual-silk',
    template: '<img *ngIf="src" [ngClass]="getClass()" [src]="src" [title]="outcome.name" (error)="src = null;errorImgLoad()"/>',
    styleUrls: ['virtual-silk.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgIf, NgClass],
})
export class VirtualSilkComponent implements OnInit {
    @Input() event: ISportEvent;
    @Input() outcome: IOutcome;
    @Input() myBets?: boolean;
    brand: string;
    isImgAvailable: boolean = false;
    @Output() statusImgLoad: EventEmitter<boolean> = new EventEmitter<boolean>();

    public src: string;

    constructor(
        public virtualSharedService: VirtualSharedService,
        public device: DeviceService,
    ) {}

    ngOnInit(): void {
        this.brand = this.device.brand ?? '';
        const silkName =
            this.outcome.silkName || this.outcome.runnerNumber || (this.outcome.racingFormOutcome && this.outcome.racingFormOutcome.silkName);
        this.src = silkName && this.virtualSharedService.getVirtualSilkSrc(this.event, silkName);
    }

    getClass(): string {
        return (
            `${this.myBets ? 'mybets-img' : ''}` +
            `${this.brand !== 'ladbrokes' ? ' mybets-img-coral' : ' mybets-img-lads'}` +
            `${this.event?.className.includes('Greyhounds') ? ' mybets-img-GH' : ' mybets-img-HR'}`
        );
    }

    errorImgLoad(): void {
        if (this.src === null) {
            this.statusImgLoad.emit(true);
        }
    }
}
